module.exports = "../dist/img/product-card-20.ad39.jpg";